/**
 * Whether a newer JobCork than the one running has been deployed.
 *
 * A single-page app loaded this morning keeps running this morning's code
 * all day; a person who saved their answers on the old page and waited for
 * the new one never saw it. The served index.html names the bundle it was
 * built with (assets/index-<hash>.js); if that is not the bundle that is
 * running, there is a newer JobCork. Asked on a timer and whenever the
 * person moves between screens; the app then offers a reload rather than
 * forcing one, so a half-typed form is never lost.
 */

const BUNDLE = /assets\/index-[A-Za-z0-9_-]+\.js/;

/** The bundle this page is running, from its own script tag. */
export function runningBundle(): string | null {
  for (const s of Array.from(document.scripts)) {
    const m = BUNDLE.exec(s.src);
    if (m) return m[0];
  }
  return null;
}

/** The bundle the server would serve now, or null when it cannot be read (offline, an error page). */
export async function servedBundle(): Promise<string | null> {
  try {
    const res = await fetch("/", { cache: "no-store", headers: { accept: "text/html" } });
    if (!res.ok) return null;
    const m = BUNDLE.exec(await res.text());
    return m ? m[0] : null;
  } catch {
    return null;
  }
}

/** True when the server's bundle is known and is not the one running. */
export async function updateAvailable(): Promise<boolean> {
  const running = runningBundle();
  if (!running) return false;
  const served = await servedBundle();
  return served !== null && served !== running;
}

export const UPDATE_CHECK_MS = 3 * 60_000;
